import { createSelector } from "reselect";

const selectAssignment = (state) => state.assignment;

export const selectAssignmentOffset = createSelector(
  [selectAssignment],
  (assignments) => assignments && assignments.offset
);
export const selectAssignmentLoadMore = createSelector(
  [selectAssignment],
  (assignments) => assignments && assignments.isLoadMore
);

export const selectAssignmentData = createSelector(
  [selectAssignment],
  (assignments) => assignments && assignments.assignmentData
);

export const selectIsFetchingAssignments = createSelector(
  [selectAssignment],
  (assignments) => assignments && assignments.isFetchingAssignments
);

export const selectAssignmentMode = createSelector(
  [selectAssignment],
  (assignments) => assignments && assignments.assignmentMode
);

export const selectErrorFetchingAssignments = createSelector(
  [selectAssignment],
  (assignments) => assignments && assignments.errorFetchingAssignments
);

///select assignmentDetail By ID
export const selectAssignmentDetailData = createSelector(
  [selectAssignment],
  (assignments) => assignments && assignments.assignmentDetailData
);

export const selectAssignmentDetailResultData = createSelector(
  [selectAssignment],
  (assignments) => assignments && assignments.assignmentDetailResultData
);

export const selectIsFetchingAssignmentDetail = createSelector(
  [selectAssignment],
  (assignments) => assignments && assignments.isFetchingAssignmentDetail
);

export const selectErrorFetchingAssignmentDetail = createSelector(
  [selectAssignment],
  (assignments) => assignments && assignments.errorFetchingAssignmentDetail
);

export const selectAssignmentCounter = createSelector(
  [selectAssignment],
  (assignments) => assignments && assignments.counter
);

///select assignment Result By ID
export const selectAssignmentResultData = createSelector(
  [selectAssignment],
  (assignments) => assignments && assignments.assignmentResultData
);

export const selectIsFetchingAssignmentResult = createSelector(
  [selectAssignment],
  (assignments) => assignments && assignments.isFetchingAssignmentResult
);
export const selectFetchingAssignmentWarning = createSelector(
  [selectAssignment],
  (assignments) => assignments && assignments.assignmentResultWarning
);

export const selectErrorFetchingAssignmentResult = createSelector(
  [selectAssignment],
  (assignments) => assignments && assignments.errorFetchingAssignmentResult
);
///select assignment Answer By ID
export const selectAssignmentAnswerData = createSelector(
  [selectAssignment],
  (assignments) => assignments && assignments.assignmentAnswerData
);

export const selectIsFetchingAssignmentAnswer = createSelector(
  [selectAssignment],
  (assignments) => assignments && assignments.isFetchingAssignmentAnswer
);

export const selectErrorFetchingAssignmentAnswer = createSelector(
  [selectAssignment],
  (assignments) => assignments && assignments.errorFetchingAssignmentAnswer
);
///select Post Assignment

export const selectIsFetchingPostAssignment = createSelector(
  [selectAssignment],
  (assignments) => assignments && assignments.isFetchingPostAssignment
);

export const selectErrorFetchingPostAssignment = createSelector(
  [selectAssignment],
  (assignments) => assignments && assignments.errorFetchingPostAssignment
);
//GetResults
export const selectResultsOffset = createSelector(
  [selectAssignment],
  (assignments) => assignments && assignments.resultOffset
);
export const selectResultLoadMore = createSelector(
  [selectAssignment],
  (assignments) => assignments && assignments.resultLoadMore
);

export const selectResultData = createSelector(
  [selectAssignment],
  (assignments) => assignments && assignments.resultData
);

export const selectIsFetchingResults = createSelector(
  [selectAssignment],
  (assignments) => assignments && assignments.isFetchingResults
);

export const selectErrorFetchingResults = createSelector(
  [selectAssignment],
  (assignments) => assignments && assignments.errorFetchingResults
);
//Get Stundets Points


export const selectStudentPointsData = createSelector(
  [selectAssignment],
  (assignments) => assignments && assignments.studentPointsData
);

export const selectIsFetchingStudentPoints = createSelector(
  [selectAssignment],
  (assignments) => assignments && assignments.isFetchingStudentPoints
);

export const selectErrorFetchingStudentPoints = createSelector(
  [selectAssignment],
  (assignments) => assignments && assignments.errorFetchingStudentPoints
);

export const selectShowNextQuestion = createSelector(
  [selectAssignment],
  (assignments) => assignments && assignments.showNextQuestion
);


//current Page

export const selectCurrentPage = createSelector(
  [selectAssignment],
  (assignments) => assignments && assignments.currentPage
);
